import { GameTransactionModel, WalletTransactionsModel } from '../models/gig';
import { PaginatedTableRowModel } from './PaginatedTable.types';

export const paginatedTableGamesMapper = (
  locale: string,
): ((data: GameTransactionModel[]) => PaginatedTableRowModel[]) => {
  return (games: GameTransactionModel[]): PaginatedTableRowModel[] => {
    if (!games) {
      return [];
    }

    return games.map(game => ({
      id: game.ActivityId,
      cells: [
        {
          text: game.Game,
        },
        {
          text:
            game.Bet > 0
              ? new Intl.NumberFormat(locale, {
                  style: 'currency',
                  currency: game.Currency,
                }).format(game.Bet)
              : '-',
          align: 'center',
        },
        {
          text:
            game.Win > 0
              ? new Intl.NumberFormat(locale, {
                  style: 'currency',
                  currency: game.Currency,
                }).format(game.Win)
              : '-',
          align: 'center',
        },
        {
          text: new Date(game.Date).toLocaleDateString(locale),
          subtext: `${new Date(game.Date).toLocaleTimeString(locale)} UTC`,
          align: 'right',
        },
      ],
    }));
  };
};

export const paginatedTableTransactionsMapper = (
  locale: string,
  translations: { transactionType: { deposit: string; withdrawal: string } },
): ((data: WalletTransactionsModel[]) => PaginatedTableRowModel[]) => {
  return (transactions: WalletTransactionsModel[]): PaginatedTableRowModel[] => {
    if (!transactions) {
      return [];
    }

    return transactions.map(transaction => ({
      id: transaction.TransactionId,
      cells: [
        {
          text:
            transaction.TransactionType === 'Deposit'
              ? translations.transactionType.deposit
              : translations.transactionType.withdrawal,
        },
        {
          text:
            transaction.Amount > 0
              ? new Intl.NumberFormat(locale, {
                  style: 'currency',
                  currency: transaction.Currency,
                }).format(transaction.Amount)
              : '-',
          align: 'center',
        },
        {
          text: transaction.Description,
          align: 'center',
        },
        {
          text: new Date(transaction.Date).toLocaleDateString(locale),
          subtext: `${new Date(transaction.Date).toLocaleTimeString(locale)} UTC`,
          align: 'right',
        },
      ],
    }));
  };
};
